<template>
    <div class="subs-add" v-title :data-title="textTitle">
        <nav-bar :navBarTitle="textTitle"></nav-bar>
        <div class="subs-head">
            <div class="subs-add-tips">
                <span></span>
                <p>订阅关注的地区及政策标签后，可实时获取推送政策</p>
                <span></span>
            </div>
            <div class="select-area-name">选择发布地区</div>
            <div :class="['select-area-item',detailInfo.id ? 'stop-click' : '']" @click="selectItem">
                <p>{{areaName ? areaName :'请选择地区'}}</p>
                <img src="@/assets/img/member/card-news-icon.png" alt="">
            </div>
            <van-popup v-model="isShowSelectArea" round position="bottom" class="popup-box" :style="{ height: '580px' }" :closeable="true" close-icon-position="top-left" :afe-area-inset-bottom="true">  
                <div class="popup-head">
                    <div class="popup-title">选择地区</div>
                    <div class="popup-confirm" @click="confirmHandle">确定</div>
                </div>
                <div class="tabs-box" :style="provinceVal.name ? tabStyle : 'width:20%'">
                    <van-tabs v-model="activeArea" animated title-inactive-color="#999999" title-active-color="#333333" color="#398DFF" line-width="20" line-height="2" :border="false">
                <van-tab :title="provinceVal.name ? provinceVal.name : '请选择'" name="a">
                    <div class="tab-box">
                    <div :class="['select-li',provinceVal.id === item.id ? 'active-li' : '']" v-for="item in province" :key="item.id" @click="slectAreaHandle(item)">{{item.name}}<span v-if="provinceVal.id === item.id" class="iconfont active-icon">&#xe615;</span></div>
                    </div>
                </van-tab>
                <van-tab v-if="provinceVal.name"  :title="cityVal.name ? cityVal.name : '请选择'" name="b">
                    <div class="tab-box">
                    <div :class="['select-li',cityVal.id === item.id ? 'active-li' : '']" v-for="item in cityArr" :key="item.id" @click="slectCityHandle(item)">{{item.name}}<span v-if="cityVal.id === item.id" class="iconfont active-icon">&#xe615;</span></div>
                    </div>
                </van-tab>
                <van-tab title="请选择" v-if="cityVal.name && areaArr.length>0"  name="c">
                    <div class="tab-box">
                    <div :class="['select-li',cityChildVal.id === item.id ? 'active-li' : '']" v-for="item in areaArr" :key="item.id" @click="slectCityChildHandle(item)">{{item.name}}<span v-if="cityChildVal.id === item.id" class="iconfont active-icon">&#xe615;</span></div>
                    </div>
                </van-tab>
                </van-tabs>
                </div>
            </van-popup>
        </div>
        <div class="key-words-wrap">
            <div class="add-key-words-h">
                <h3>添加补贴类型关键词</h3>
                <div class="add-key-words-h-l">
                    <span>{{tagArr.length}}</span>/6
                </div>
            </div>
            <div class="add-key-words-tag-wrap">
                <div class="add-key-words-tag" v-for="(item,index) in tagArr" :key="index+'0'"><p>{{item}}</p><img @click="closeHandle(index)" src="@/assets/img/member/close-icon.png"></div>
                <div class="add-btn-tag" @click="addTagsHandle"><img src="@/assets/img/member/sub-card-add-icon.png" />添加关键词</div>
            </div>
            <div class="split-line"></div>
            <h5 class="recommend">推荐关键词</h5>
            <div class="add-key-words-tag-wrap">
            <div class="add-key-words-tag" @click="recommendHandle(item)" v-for="(item) in recommendArr" :key="item.keywordName"><p>{{item.keywordName}}</p></div>
            </div>
        </div>
        <van-popup v-model="isShowAddTag" round position="bottom" :style="{ padding:'20px' }" >
            <div class="pop-add-tag-h"><p>添加关键词</p><span class="iconfont iconlujing2" @click="isShowAddTag=false"></span></div>
            <div class="pop-add-tag-content">
                <van-field
                    v-model="keywords"
                    rows="2"
                    autosize
                    label=""
                    type="textarea"
                    maxlength="4"
                    placeholder="请输入"
                    show-word-limit
                    />
            </div>
                <div class="add-tag-key-line"></div>
                <div class="pop-add-tag-btn" @click="addTagHandle">保存</div>
        </van-popup>
        <div class="addbtn-btn">
            <div class="addbtn" @click="addbtnHandle">立即订阅</div>
        </div>
        
    </div>
</template>
<script>
import { updateMySubscribe,addMySubscribe,queryKeyword} from "@/api/api_member.js"
import {  Area } from '@/api/api_home'
import { trim,checkEmojiRule} from '@/utils/util'
export default {
    data(){
        return {
            isShowSelectArea:false,
            cityArr:[],
            areaArr:[],
            province:[],
            cityVal:{},
            cityChildVal:{},
            provinceVal:{},
            activeArea:'',
            areaName:'',
            tabStyle:'',
            tagArr:[],
            isShowAddTag:false,
            keywords:"",
            detailInfo:{},
            recommendArr:[],
            isHaveData:false,
            textTitle:'添加',
        }
    },
    created(){
        this.detailInfo=this.$route.query
        this.getInfoKeyWord()
        if(this.detailInfo.id){
            this.textTitle='编辑'
            this.areaName=this.detailInfo.region
            this.tagArr=JSON.parse(this.detailInfo.keywords)
        }
    },
    methods:{
        getInfoKeyWord(){
            queryKeyword().then((res)=>{
                if(res.ok===true){
                    this.recommendArr=res.data
                }
                
            })
        },
        upDataMysubscribe(){
            let keywords=this.tagArr.length>0 && this.tagArr.join(',')
            let params={
                id:this.detailInfo.id,
                keyword:keywords,
                provinceId:this.detailInfo.provinceId,
                regionId:this.detailInfo.regionId,
                cityId:this.detailInfo.cityId
            }
            updateMySubscribe(params).then((res)=>{
                if(res.ok===true){
                    this.$toast('更新成功')
                    this.$router.go(-1)
                }
            })
        },
        addbtnHandle(){
            if(!this.areaName){
                this.$toast('发布地区不能为空')
                    return false
            }
            if(this.tagArr.length===0){
                    this.$toast('请先添加关键词再进行订阅')
                    return false
                }
            if(this.tagArr.length>6){
                this.$toast('最多添加6个关键词')
                return false
            }
            if(this.detailInfo.id){
                    this.upDataMysubscribe()
            }else{
                this.addMysubscribe()
            }
        },
        addMysubscribe(){
            let tagarr=this.tagArr.join(',')
            let params={
                provinceId:this.provinceVal.id ?  this.provinceVal.id  : null,
                cityId: this.cityVal.id ? this.cityVal.id : null,
                regionId: this.cityChildVal.id ? this.cityChildVal.id : null,
                keyword:tagarr
            }
            addMySubscribe(params).then((res)=>{
                if(res.code==='000500'){
                    this.$toast(res.msg)
                }else if(res.ok===true){
                    this.$router.go(-1)
                }
                
            })
        },
        addTagsHandle(){
            this.isShowAddTag=true
            this.keywords=""
        },
        selectItem(){
            this.isShowSelectArea=true
            this.getRegisterArea('province',0)
        },
        getRegisterArea(type,regionId){
            let params={
                regionId:regionId,
                regionVersion:'1'
            }
            Area(params).then(res=>{
                let that=this
                if(res.ok===true){
                    if(type==='province'){
                        this.province=res.data
                        //编辑回显数据
                        if(this.detailInfo.provinceId){
                            console.log('省份0')
                            this.province.forEach(item=>{
                                if(parseInt(item.id)===parseInt(this.detailInfo.provinceId)){
                                    console.log('省份')
                                    this.provinceVal.id=item.id
                                    this.provinceVal.name=item.name
                                }
                            })
                        }
                    }else if(type==='city'){
                        if(regionId===-1){
                            this.activeArea='a'
                            return
                        }else{
                            this.activeArea='b'
                        }
                        this.cityArr=res.data
                         //编辑回显数据
                        if(this.detailInfo.cityId){
                            this.cityArr.forEach(item=>{
                                if(parseInt(item.id)===parseInt(this.detailInfo.cityId)){
                                    this.cityVal.id=item.id
                                    this.cityVal.name=item.name
                                }
                            })
                        }
                    }else{
                        this.areaArr=res.data
                         //编辑回显数据
                        if(this.detailInfo.regionId){
                            this.areaArr.forEach(item=>{
                                if(parseInt(item.id)===parseInt(this.detailInfo.regionId)){
                                    this.cityChildVal.id=item.id
                                    this.cityChildVal.name=item.name
                                }
                            })
                        }
                        if(this.areaArr.length>0){
                            this.tabStyle='width:60%'
                            this.cityChildVal.name="请选择"
                            setTimeout(()=>{
                                that.activeArea='c'
                            },5)
                            
                        }
                    }
                    
                }
            })
        },
        confirmHandle(){
            if(this.areaArr.length>0 && this.cityChildVal.name==='请选择'){
                this.$toast('请选择区域')
                return false
            }
            if(this.detailInfo.id){
                //回显数据
                if(this.detailInfo.provinceId){
                    this.areaName=this.detailInfo.region
                }
            }else{
                if(this.cityVal.name==='请选择'){
                    this.areaName=this.provinceVal.name
                }else if(this.provinceVal.name){
                    this.areaName=this.provinceVal.name+this.cityVal.name+this.cityChildVal.name
                }
            }
            this.isShowSelectArea=false
        },
        slectAreaHandle(val){
            this.provinceVal=val
            this.cityVal.name="请选择"
            this.cityVal.id=''
            this.getRegisterArea('city',val.id)
        },
        slectCityHandle(val){
            this.cityVal=val
            this.cityChildVal.name=""
            this.cityChildVal.id=""
            this.getRegisterArea('area',val.id)
            
        },
        slectCityChildHandle(val){
            this.cityChildVal=val
        },
        closeHandle(index){
            this.tagArr.splice(index,1)
        },
        addTagHandle(){
            let keywords=trim(this.keywords)
            if(!keywords){
                this.$toast('关键词不可为空')
                return false 
            }else if(checkEmojiRule(keywords)){
                this.$toast('不可以输入表情')
                return false
            }else if(keywords && keywords.length<2){
                this.$toast('关键字长度限制为2-4个字')
                return false 
            }else if(this.tagArr.length>5){
                this.$toast('最多添加6个关键词')
                return false
            }else {
                let isHaveData= this.tagArr.some((item)=>{
                if(keywords === item){
                    isHaveData=true
                    return isHaveData
                    }
            })
            if(!isHaveData){
                this.tagArr.push(keywords)
                this.isShowAddTag=false
            }else{
                this.$toast('关键词不可重复添加')
            }
            }
        },
        recommendHandle(obj){
            if(this.tagArr.length>=6){
                this.$toast('最多添加6个关键词')
                return false
            }
            let isHaveData= this.tagArr.some((item)=>{
                if(obj.keywordName === item){
                    isHaveData=true
                    return isHaveData
                    }
            })
            if(!isHaveData){
                this.tagArr.push(obj.keywordName)
            }
        }
    }
}
</script>
<style scoped lang="less">
.subs-add{
    background: #F5F5F5;
    min-height: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: stretch;
    align-content: stretch;
    .subs-head{
        background: #fff;
        padding-bottom: 20px;
    }
    .subs-add-tips{
        width: 100%;
        height: 40px;
        background: #398DFF;
        line-height: 40px;
        display: flex;
        justify-content: center;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #fff;
        align-items: center;
        span{
            display: block;
            width: 25px;
            height: 1px;
            background-image: linear-gradient(to right, rgba(255,255,255,1) , rgba(0,0,0,0));
        }
        p{
            margin:0 8px;
        }
    }
    .select-area-name{
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 16px;
        margin:20px 0 0 20px;
    }
    .select-area-item{
        width: 335px;
        height: 40px;
        background: #F8F8F8;
        border-radius: 3px;
        margin:14px 20px 20px;
        line-height: 40px;
        display: flex;
        justify-content: space-between;
        padding: 0 16px;
        align-items: center;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        img{
            width:7px;
            height: 12px;
        }
    }
    .stop-click{
        opacity: 0.5;
        pointer-events: none;
    }
    .popup-head{
    display: flex;
    justify-content: flex-end;
    margin:20px 15px 0 0;
    font-size:14px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:@baseBlack;
line-height:14px;
align-items: center;
.popup-title{
    font-size:18px;
font-family:PingFangSC-Medium,PingFang SC;
font-weight:500;
color:rgba(51,51,51,1);
line-height:18px;
}
.popup-confirm{
    margin-left: 103px;
}
}
.tabs-box{
    width:30%;
    margin:35px 0 0 10px;
    /deep/ .van-tabs__content{
        width: 375px;
    }
    /deep/ .van-tabs__wrap{
    margin: 0;
}
    .tab-box{
        padding: 40px 0 0 20px;
        max-height: 393px;
        overflow-x: scroll;
        .select-li{
        font-size:18px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:20px;
        margin-bottom: 28px;
        display: flex;
        align-items: center;
        .active-icon{
            font-size: 12px;
            transform: scale(0.7);
            color: #398DFF;
            display: inline-block;
            margin-left: 10px;
        }
        }
.active-li{
    color: #398DFF;
}
    }
    /deep/ .van-tab{
        font-size: 16px;
    }
}
.key-words-wrap{
    margin-top:10px;
    background: #fff;
    padding: 20px;
    .add-key-words-h{
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        h3{
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 16px;
        }
        .add-key-words-h-l{
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            line-height: 16px;
            span{
                color: rgba(57, 141, 255, 1);
            }
        }
    }
    .add-key-words-tag-wrap{
        display: flex;
        flex-wrap: wrap;
        margin-right: -3.5px;
        .add-key-words-tag{
            padding: 0 12px;
            height: 34px;
            background: #EBF3FF;
            border-radius: 3px;
            font-size: 13px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #398DFF;
            text-align: center;
            line-height: 34px;
            display: flex;
            align-items: center;
            margin: 0 3.5px 8px;
            justify-content: center;
            img{
                width:10px;
                height: 10px;
                display: inline-block;
                margin-left: 8px;
            }
        }
    }
}
.add-btn-tag{
    width: 107px;
    height: 34px;
    background: rgba(57, 141, 255, 0);
    border-radius: 3px;
    border: 1px solid #398DFF;
    font-size: 13px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #398DFF;
    line-height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
        width:12px;
        height: 12px;
        margin-right: 6px;
    }
    }
    .pop-add-tag-h{
        display: flex;
        justify-content: space-between;
        padding:0 0 40px 0;
        p{
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 18px;
        }
        .iconlujing2{
            font-size: 16px;
            color: rgba(153, 153, 153, 1);
        }
    }
    .pop-add-tag-content{
        /deep/ .van-cell{
            font-size: 16px;
        }
        /deep/ .van-field__word-limit{
            font-size: 16px;
        }
        /deep/ .van-field__word-num{
            color: rgba(57, 141, 255, 1);
            
        }
    }
    .add-tag-key-line{
        width: 335px;
        height: 1px;
        background: #EEEEEE;
        margin-top:15px;
    }
    .pop-add-tag-btn{
        width: 335px;
        height: 40px;
        background: #398DFF;
        border-radius: 5px;
        line-height: 40px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
    }
    .split-line{
        width: 335px;
        height: 1px;
        border: 1px solid #F2F2F2;
        margin-top:52px;
    }
    .recommend{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #999999;
        line-height: 16px;
        margin:19px 0 14px;
    }
    .addbtn-btn{
        flex:1;
        display: flex;
        align-items:flex-end;
    }
.addbtn{
    width: 343px;
    height: 44px;
    background: #398DFF;
    border-radius: 5px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 44px;
    text-align: center;
    margin:24px auto;
}
}
</style>